import script from "./ModalDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDelete.vue?vue&type=script&setup=true&lang=js"

import "./ModalDelete.vue?vue&type=style&index=0&id=4a0098aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0098aa"]])

export default __exports__